import React, {
  useEffect,
  useState,
} from "react";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Badge,
} from "react-bootstrap";

import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  RiShareForwardLine,
  RiDownloadFill,
} from "react-icons/ri";

import {
  MdOutlineBlock,
  MdOutlineDeleteOutline,
} from "react-icons/md";

import { HiOutlineMail } from "react-icons/hi";

import { FaArrowLeft } from "react-icons/fa";

import { SiTicktick } from "react-icons/si";

import { ImConfused } from "react-icons/im";

import ApiService from "../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

function Adminjobproview() {

  const { id } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const [candidate, setCandidate] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  /* =========================================
     LOAD CANDIDATE
  ========================================= */

  useEffect(() => {

    loadCandidate();

  }, [id]);

  const loadCandidate = async () => {

    try {

      setLoading(true);

      console.log(
        "ROUTE PARAM ID :",
        id
      );

      console.log(
        "LOCATION STATE :",
        location.state
      );

      /* =========================================
         GET CANDIDATE FROM NAVIGATION STATE
      ========================================= */

      if (
        location.state?.candidate
      ) {

        const candidateData =
          location.state.candidate;

        console.log(
          "CANDIDATE RECEIVED :",
          candidateData
        );

        setCandidate(candidateData);

        setLoading(false);

        return;
      }

      /* =========================================
         FALLBACK API CALL
      ========================================= */

      try {

        const response =
          await JobAPI.getApplicationById(
            id
          );

        console.log(
          "API CANDIDATE RESPONSE :",
          response
        );

        if (response?.data) {

          setCandidate(
            response.data
          );

        } else {

          setCandidate(null);
        }

      } catch (apiError) {

        console.log(
          "API ERROR :",
          apiError
        );

        setCandidate(null);
      }

    } catch (error) {

      console.log(
        "LOAD ERROR :",
        error
      );

      setCandidate(null);

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     STATUS UPDATE
  ========================================= */

  const updateStatus =
    async (status) => {

      try {

        if (
          status ===
          "Shortlisted"
        ) {

          await JobAPI.shortlistApplication(
            candidate.id
          );

        } else if (
          status ===
          "Rejected"
        ) {

          await JobAPI.rejectApplication(
            candidate.id
          );
        }

        setCandidate((prev) => ({
          ...prev,
          status,
        }));

        alert(
          `Candidate ${status}`
        );

      } catch (error) {

        console.log(
          "STATUS UPDATE ERROR :",
          error
        );

        alert(
          "Failed to update status"
        );
      }
    };

  /* =========================================
     DOWNLOAD RESUME
  ========================================= */

  const handleDownload =
    () => {

      try {

        const resume =
          candidate?.resume ||
          candidate?.resume_file;

        if (!resume) {

          alert(
            "Resume not available"
          );

          return;
        }

        window.open(
          resume,
          "_blank"
        );

      } catch (error) {

        console.log(
          "DOWNLOAD ERROR :",
          error
        );

        alert(
          "Failed to download resume"
        );
      }
    };

  /* =========================================
     DELETE
  ========================================= */

  const handleDelete =
    () => {

      const confirmDelete =
        window.confirm(
          "Are you sure you want to delete this candidate?"
        );

      if (!confirmDelete)
        return;

      alert(
        "Delete functionality ready"
      );

      navigate(-1);
    };

  /* =========================================
     LOADING
  ========================================= */

  if (loading) {

    return (

      <div className="text-center mt-5">

        <div className="spinner-border text-primary" />

        <p className="mt-3">
          Loading Candidate...
        </p>

      </div>
    );
  }

  /* =========================================
     NOT FOUND
  ========================================= */

  if (!candidate) {

    return (

      <div className="text-center mt-5">

        <h3 className="text-danger">

          Candidate Not Found

        </h3>

        <Button
          className="mt-3"
          onClick={() =>
            navigate(-1)
          }
        >

          <FaArrowLeft />
          {" "}
          Back

        </Button>

      </div>
    );
  }

  /* =========================================
     UI
  ========================================= */

  return (

    <Container
      fluid
      className="py-4 mt-4 bg-light"
    >

      {/* TOP */}

      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">

        <div>

          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() =>
              navigate(-1)
            }
          >

            <FaArrowLeft />
            {" "}
            Back to Candidates

          </Button>

          <h2 className="fw-bold mt-3">

            Candidate Profile

          </h2>

        </div>

        <Badge
          bg={
            candidate.status ===
            "Shortlisted"

              ? "success"

              : candidate.status ===
                "Rejected"

              ? "danger"

              : candidate.status ===
                "Maybe"

              ? "warning"

              : "secondary"
          }
          className="fs-6 p-2"
        >

          {candidate.status ||
            "NEW"}

        </Badge>

      </div>

      {/* ACTION BUTTONS */}

      <div className="d-flex flex-wrap gap-2 justify-content-end mb-4">

        <Button
          size="sm"
          variant="success"
          onClick={() =>
            updateStatus(
              "Shortlisted"
            )
          }
        >

          <SiTicktick />
          {" "}
          Shortlist

        </Button>

        <Button
          size="sm"
          variant="warning"
          onClick={() =>
            updateStatus(
              "Maybe"
            )
          }
        >

          <ImConfused />
          {" "}
          Maybe

        </Button>

        <Button
          size="sm"
          variant="outline-danger"
          onClick={() =>
            updateStatus(
              "Rejected"
            )
          }
        >

          <MdOutlineBlock />
          {" "}
          Reject

        </Button>

        <Button
          size="sm"
          variant="primary"
        >

          <HiOutlineMail />
          {" "}
          Email

        </Button>

        <Button
          size="sm"
          variant="secondary"
        >

          <RiShareForwardLine />
          {" "}
          Forward

        </Button>

        <Button
          size="sm"
          variant="outline-secondary"
          onClick={
            handleDownload
          }
        >

          <RiDownloadFill />
          {" "}
          Download Resume

        </Button>

        <Button
          size="sm"
          variant="outline-danger"
          onClick={
            handleDelete
          }
        >

          <MdOutlineDeleteOutline />
          {" "}
          Delete

        </Button>

      </div>

      {/* PERSONAL INFO */}

      <ProfileCard title="Personal Information">

        <Field
          label="First Name"
          value={
            candidate.firstName ||
            candidate.first_name
          }
        />

        <Field
          label="Last Name"
          value={
            candidate.lastName ||
            candidate.last_name
          }
        />

        <Field
          label="Email"
          value={candidate.email}
        />

        <Field
          label="Phone"
          value={
            candidate.phone ||
            candidate.phone_number
          }
        />

        <Field
          label="Gender"
          value={candidate.gender}
        />

        <Field
          label="Location"
          value={candidate.location}
        />

        <Field
          label="Qualification"
          value={
            candidate.qualification ||
            candidate.highest_qualification
          }
        />

        <Field
          label="Key Skills"
          value={
            candidate.keySkills ||
            candidate.key_skills
          }
        />

        <Field
          label="Experience Type"
          value={
            candidate.experienceType ||
            candidate.experience_type
          }
        />

        <Field
          label="Applied At"
          value={
            candidate.appliedAt ||
            candidate.applied_at
          }
        />

      </ProfileCard>

    </Container>
  );
}

/* =========================================
   PROFILE CARD
========================================= */

const ProfileCard = ({
  title,
  children,
}) => (

  <Card className="mb-4 shadow-sm border-0">

    <Card.Header className="bg-primary text-white fw-bold">

      {title}

    </Card.Header>

    <Card.Body>

      <Row>

        {children}

      </Row>

    </Card.Body>

  </Card>
);

/* =========================================
   FIELD
========================================= */

const Field = ({
  label,
  value,
}) => (

  <Col
    md={6}
    className="mb-3"
  >

    <div className="border rounded p-2 h-100 bg-white">

      <strong>

        {label} :

      </strong>

      <div className="mt-1 text-muted">

        {value || "N/A"}

      </div>

    </div>

  </Col>
);

export default Adminjobproview;